import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ControlCreditoService } from '@controlCredito/control-credito.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModel } from '@shared/models/ErrorModel';
import { NivelControlCredito } from '@shared/models/controlCredito/NivelControlCredito';
import { SharedModule } from '@shared/shared.module';
import { MessageService } from '@shell/message.service';

@Component({
  selector: 'app-nivel-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  templateUrl: './nivel-form.component.html',
  styleUrl: './nivel-form.component.scss'
})
export class NivelFormComponent implements OnInit {
  form: FormGroup = new FormGroup({});

  @Input() nuevoNivel: boolean;
  @Input() nivelSeleccionado: NivelControlCredito = null;
  @Output() guardar = new EventEmitter<any>();

  guardandoCambios: boolean;

  constructor(private fb: FormBuilder, private controlCreditoService: ControlCreditoService, private activeModal: NgbActiveModal, private messageService: MessageService) { }

  ngOnInit(): void {
    this.crearFormulario();
  }

  crearFormulario() {
    this.form = this.fb.group({
      nombreNivel: ['', Validators.required],
      excedidoAutorizadoUSD: [{ value: null, disabled: true }, Validators.required],
      excedidoActivo: [false],
      vencidoAutorizadoUSD: [{ value: null, disabled: true }, Validators.required],
      vencidoActivo: [false],
      apruebaBloqueo: [false]
    });

    if (!this.nuevoNivel && this.nivelSeleccionado) {
      this.form.patchValue(this.nivelSeleccionado);
      this.actualizarEstadoCampos();
    }

    this.form.get('excedidoActivo')?.valueChanges.subscribe((activo: boolean) => {
      const control = this.form.get('excedidoAutorizadoUSD');
      if (activo) {
        control?.enable();
      } else {
        control?.disable();
        control?.reset();
      }
    });

    this.form.get('vencidoActivo')?.valueChanges.subscribe((activo: boolean) => {
      const control = this.form.get('vencidoAutorizadoUSD');
      if (activo) {
        control?.enable();
      } else {
        control?.disable();
        control?.reset();
      }
    });
  }

  actualizarEstadoCampos() {
    if (this.nivelSeleccionado.excedidoActivo) {
      this.form.get('excedidoAutorizadoUSD')?.enable();
    } else {
      this.form.get('excedidoAutorizadoUSD')?.disable();
    }

    if (this.nivelSeleccionado.vencidoActivo) {
      this.form.get('vencidoAutorizadoUSD')?.enable();
    } else {
      this.form.get('vencidoAutorizadoUSD')?.disable();
    }
  }

  crearNivel(nivel) {
    this.guardandoCambios = true;
    this.controlCreditoService.crearNuevoNivel(nivel).subscribe(n => {
      this.activeModal.close(n);
    }, (err: ErrorModel) => {
      this.messageService.showErrorMessage(err.description + "\n" + err.message);
      this.guardandoCambios = false;
    })
  }

  editarNivel(nivel) {
    this.guardandoCambios = true;
    nivel.id = this.nivelSeleccionado.id;
    this.controlCreditoService.editarNivel(nivel).subscribe(n => {
      this.guardandoCambios = false;
      this.activeModal.close(n);
    }, (err: ErrorModel) => {
      this.messageService.showErrorMessage(err.description + "\n" + err.message);
      this.guardandoCambios = false;
    })
  }

  onGuardar() {
    const dto: NivelControlCredito = this.form.value;
    if (this.form.valid && this.validarCamposSeleccionados(dto)) {
      dto.vencidoAutorizadoUSD = Number(dto.vencidoAutorizadoUSD);
      dto.excedidoAutorizadoUSD = Number(dto.excedidoAutorizadoUSD);
      this.nuevoNivel ? this.crearNivel(dto) : this.editarNivel(dto);
    } else {
      this.form.markAllAsTouched();
    }
  }

  onCancelar() {
    this.activeModal.dismiss();
  }

  validarCamposSeleccionados(dto: NivelControlCredito): boolean {
  const tieneExcedido = dto.excedidoActivo;
  const tieneVencido = dto.vencidoActivo && dto.vencidoAutorizadoUSD > 0;
  const tieneBloqueo = dto.apruebaBloqueo;

  return tieneExcedido || tieneVencido || tieneBloqueo;
}


  get nombreNivel() {
    return this.form.get('nombreNivel');
  }
}

